import styled from "styled-components";

export const PlanInTileExternalContainer = styled.div`
    width: 100%;
    padding: 20px;
    @media(min-width: 768px){
        padding: 35px;
    }
    @media(min-width: 1024px){
        padding: 50px;
    }
`;

// ------------------------------------------------
// show the already plan

export const ShowPlanInTileContainer = styled.div`
    background: rgba(0,0,0,0.3);
    width: 100%;
    border-radius: 10px;
    padding: 10px;
    @media(min-width: 768px){
        border-radius: 10px;
        padding: 15px;
    }
`

export const ShowPlanInTileInternalContainer = styled.div`
    width: 100%;
    display: flex;
    gap: 10px;
    flex-direction: column;
    @media(min-width: 768px){
        flex-direction: row;
        gap: 15px;
    }
`


// section one 

export const SPITSectionOne = styled.div`
    width: 100%;
    border-radius: 20px;
    padding: 20px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background: rgba(0,0,0,0.5);
    @media(min-width: 768px) {
        width: calc(50% - 15px);
    }
`

export const SPITProgressHeading = styled.span`
    font-size: ${props => props?.small ? '14px' : '16px'};
    text-transform: uppercase;
    color: #FFF;
    font-weight: 500;
    text-decoration: underline;
    flex-shrink: 0;
`

export const SPITProgressContainer = styled.div`
    border-radius: 15px;
    background: #3E6379;
    height: 4.7px;
    width: 100%;
    overflow: hidden;
    position: relative;
`

export const SPITProgressFilled = styled.div`
    position: absolute;
    background: #44FF33;
    top: 0;
    left: 0;
    height: 100%;
    width: ${props => `${props?.progress}%`};
    transition: all 0.4s ease-in-out;
`

export const SPITMainItemPictureAndDetailContainer = styled.div`
    width: 100%;
    height: 250px;
    display: flex;
    gap: 13px;
    @media (min-width: 768px) {
        height: 250px;
    }
`

export const SPITMainItemPicture = styled.div`
    height: 100%;
    width: 100px;
    flex-shrink: 0;
    border-radius: 7px;
    position: relative;
    cursor: pointer;
    background: ${props => props?.url && `url(${props?.url})`};
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    overflow: hidden;
    @media (min-width: 768px) {
        width: 150px;
    }
`

export const SPITMainItemPictureDayContainer = styled.div`
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: center;
    bottom: 9px;
    left: 0;
    right: 0;
    margin: 0 auto;
    color: #FFF;
    font-weight: 500;
    cursor: default;
    width: 69px;
    height: 23px;
    background: rgba(0,0,0,0.25);
    border: 1px solid #FFF;
    border-radius: 6px;
    font-size: 16px;
    text-transform: uppercase;
`

export const SPITMainItemPictureTopInfo = styled.div`
    width: 100%;
    padding: 3px 0;
    background: rgba(0,0,0,0.2);
    color: #FFF;
    text-transform: uppercase;
    display: flex;
    font-size: 14px;
    text-align: center;
    display: flex;
    justify-content: center;
    @media (min-width: 768px) {
        font-size: 16px;
    }
`

export const SPITMainItemDetailTitle = styled.div`
    flex-shrink: 0;
    font-size: 16px;
    font-weight: 500;
    color: #FFF;
    margin-bottom: 6px;
    text-transform: uppercase;
    @media(min-width: 768px) {
        font-size: 20px;
    }
`

export const SPITMainItemDetailCategory = styled.div`
    padding: 2px 5px;
    border: 1px solid #FFF;
    color: #FFF;
    flex-shrink: 0;
    font-size: 14px;
    border-radius: 16px;
`

export const SPITMainItemDetailDescription = styled.div`
    color: #FFF;
    font-size: 13px;
    margin-bottom: 10px;
    @media (min-width: 768px) {
        font-size: 16px;
    }
`

export const SPITMainItemStartButton = styled.button`
    width: 92px;
    border-radius: 26px;
    background: #767676;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #FFF;
    flex-shrink: 0;
    gap: 5px;
    text-transform: uppercase;
    font-size: 16px;
    &:hover{
        background: #505050;
    }
`


//section two

export const SPITSectionTwo = styled.div`
    width: 100%;
    padding: 20px;
    border-radius: 20px;
    background: rgba(0,0,0,0.5);
    @media(min-width: 768px) {
        width: calc(50% - 15px);
    }
`

export const SPITOtherItemsContainer = styled.div`
    // height: 250px;
    // overflow: auto;
    // /* For all browsers */
    // ::-webkit-scrollbar {
    // width: 5px; /* Set the width of the scrollbar for WebKit-based browsers */
    // }

    // ::-webkit-scrollbar-thumb {
    // background-color: #bac3cc; /* Set the color of the scrollbar thumb for WebKit-based browsers */
    // }

    // /* For Firefox */
    // scrollbar-width: thin;
    // scrollbar-color: #bac3cc #fff;
`

export const SPITOtherItem = styled.div`
    width: 100%;
    position: relative;
    min-height: 104px;
    cursor: ${props => props?.clickable ? 'pointer' : 'default'};
    border-radius: 4px;
    margin-bottom: 8px;
    background: ${props => props?.imgLink && `url(${props?.imgLink})`};
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    @media (min-width: 1080px) {
        min-height: 120px;
    }
`

export const SPITOtherItemDarkOverlay = styled.div`
    position: absolute;
    top: 0;
    width: 60%;
    height: 100%;
    background: rgba(0,0,0,0.25);
    padding: 12px;
    color: #FFF;
    text-transform: uppercase;
    font-size: 14px;
    font-weight: 500;
    @media(min-width: 768px){
        font-size: 20px;
    }
`

export const SPITOtherItemPictureDayContainer = styled.div`
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: center;
    top: 9px;
    right: 9px;
    color: #FFF;
    font-weight: 500;
    cursor: default;
    width: 69px;
    height: 23px;
    background: rgba(0,0,0,0.25);
    border: 1px solid #FFF;
    border-radius: 6px;
    font-size: 16px;
    text-transform: uppercase;
`

export const SPITOtherItemLockContainer = styled.div`
    background: #FFFFFF73;
    border-radius: 50%;
    width: 26px;
    height: 26px;
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    left: calc(50% - 13px);
    bottom: 10px;
    @media(min-width: 768px){
        width: 34px;
        height: 34px;
        left: calc(50% - 17px);
        bottom: 10px;
    }
`

// -----------------------------------------------
// create new plan

export const CreatePlanInTileContainer = styled.div`
    width: 138px;
    height: 100px;
    border-radius: 5px;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 18px;
    font-weight: 700;
    color: #FFF;
    cursor: pointer;
    background: linear-gradient(120.13deg ,#FFAFBD 3.17%,#FFC3A0 105.79%);
    @media(min-width: 768px){
        width: 199px;
        height: 150px;
        border-radius: 8px;
        font-size: 22px;
    }
    @media(min-width: 1024px){
        width: 289px;
        height: 200px;
        border-radius: 10px;
        font-size: 26px;
}
`